export const NETWORK_PRODUCTION = 1;
